export default __webpack_public_path__ + "static/media/one.47d62a47.png";